import { useEffect, useState } from "react";
import { getSeoData } from "./Seodata";
import { generateBreadcrumbs } from "./BredcrumbLdjson";

export default async function SEO({ FullURL }: { FullURL: string }) {
    const breadcrumbs = generateBreadcrumbs(FullURL);
    const seoData = await getSeoData(FullURL);

    // const [seoData, setSeoData] = useState<any>(getSeoData(FullURL));

    // useEffect(() => {
    //     getSeoData(FullURL).then(setSeoData);
    // }, [FullURL]);

    // console.log("SEO Datas", seoData);

    const siteURL = process.env.NEXT_PUBLIC_BASE_URL;

    return (
        <head>
            <title>{seoData?.seo_title || "GetBiz Solutions - HRMS, CRM & More for Business Success"}</title>
            <meta name="description" content={seoData?.seo_description || "Streamline your business with GetBiz Solutions' HRMS, CRM, and more, designed to enhance productivity and drive growth with expert software tools."} />
            <meta name="keywords" content={seoData?.seo_keyword || "IT Support, Web Design, Digital Marketing"} />

            <link rel="canonical" href={siteURL + FullURL || siteURL} />

            {/* SEO OG INFO */}
            <meta property="og:locale" content="en_US" />
            <meta property="og:site_name" content={process.env.NEXT_PUBLIC_SITE_NAME || "GetBiz Solutions"} />
            <meta property="og:url" content={siteURL + FullURL || siteURL} />
            <meta property="og:title" content={seoData?.seo_title || "GetBiz Solutions - HRMS, CRM & More for Business Success"} />
            <meta property="og:description" content={seoData?.seo_description || "Streamline your business with GetBiz Solutions' HRMS, CRM, and more, designed to enhance productivity and drive growth with expert software tools."} />
            <meta property="og:image" content={seoData?.og_image || `${siteURL}/assets/data/seoimages/Home.png`} />
            <meta name="og:image:width" content="1200" />
            <meta name="og:image:height" content="630" />
            <meta name="og:image:alt" content={process.env.NEXT_PUBLIC_SITE_NAME || "GetBiz Solutions"} />
            <meta name="og:image:type" content="image/webp" />
            <meta property="og:type" content="website" />

            {/* SEO TWITTER INFO */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta property="twitter:title" content={seoData?.seo_title || "GetBiz Solutions - HRMS, CRM & More for Business Success"} />
            <meta property="twitter:site_name" content={process.env.NEXT_PUBLIC_SITE_NAME || "GetBiz Solutions"} />
            <meta name="twitter:site" content="@Getbiz_Solution" />
            <meta property="twitter:url" content={siteURL + FullURL} />
            <meta property="twitter:description" content={seoData?.seo_description || "Streamline your business with GetBiz Solutions' HRMS, CRM, and more, designed to enhance productivity and drive growth with expert software tools."} />
            <meta property="twitter:image" content={seoData?.og_image || `${siteURL}/assets/data/seoimages/Home.png`} />
            <meta name="twitter:image:width" content="1200" />
            <meta name="twitter:image:height" content="630" />
            <meta name="twitter:image:alt" content={process.env.NEXT_PUBLIC_SITE_NAME || "GetBiz Solutions"} />
            <meta name="twitter:image:type" content="image/webp" />

            <meta name="robots" content="index, follow" />

            {seoData?.blog === true && (
                <>
                    <meta property="article:published_time" content={seoData?.created_date} />
                    <meta property="article:modified_time" content={seoData?.updated_date} />
                </>
            )}

            {/* Organization */}
            {seoData?.ld_json &&
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(seoData.ld_json)
                    }}
                />}

            {/* Breadcrumb JSON-LD */}
            {breadcrumbs && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: breadcrumbs ?? "" }}
                />
            )}

            {seoData?.faq && seoData.faq.length > 0 && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData.faq) }}
                />
            )}

            {/* JSON-LD for Product */}
            {/* {metadata.product && metadata.product.length > 0 && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(metadata.product) }}
                />
            )} */}

            {/* {seoData?.additionalldjson.length > 0 && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(seoData?.additionalldjson) }}
                />
            )} */}


        </head>
    );
}
